import {
  FaAddressBook,
  FaAddressCard,
  FaAngleDown,
  FaAngleLeft,
  FaAngleRight,
  FaAngleUp,
  FaAnglesLeft,
  FaAnglesRight,
  FaArrowDown,
  FaArrowDownWideShort,
  FaArrowLeft,
  FaArrowRight,
  FaArrowRightArrowLeft,
  FaArrowRotateLeft,
  FaArrowRotateRight,
  FaArrowUp,
  FaArrowUp19,
  FaArrowUpWideShort,
  FaArrowsRotate,
  FaAsterisk,
  FaAt,
  FaBabyCarriage,
  FaBan,
  FaBars,
  FaBarsStaggered,
  FaBell,
  FaBellSlash,
  FaBolt,
  FaBook,
  FaBookOpen,
  FaBookmark,
  FaBoxArchive,
  FaBuilding,
  FaBullhorn,
  FaCakeCandles,
  FaCalculator,
  FaCalendarCheck,
  FaCalendarDays,
  FaCalendarXmark,
  FaCamera,
  FaCaretDown,
  FaCaretLeft,
  FaCaretRight,
  FaCaretUp,
  FaChartArea,
  FaChartBar,
  FaChartColumn,
  FaChartLine,
  FaChartPie,
  FaCheck,
  FaChevronDown,
  FaChevronLeft,
  FaChevronRight,
  FaCircle,
  FaCircleCheck,
  FaCircleDot,
  FaCircleExclamation,
  FaCircleInfo,
  FaCircleMinus,
  FaCirclePlay,
  FaCirclePlus,
  FaCircleQuestion,
  FaCircleUser,
  FaCircleXmark,
  FaClipboard,
  FaClipboardCheck,
  FaClipboardList,
  FaClipboardQuestion,
  FaClock,
  FaClockRotateLeft,
  FaCloudArrowDown,
  FaCloudArrowUp,
  FaCode,
  FaComment,
  FaCommentDots,
  FaComments,
  FaCompress,
  FaCopy,
  FaCube,
  FaCubes,
  FaDatabase,
  FaDoorOpen,
  FaDownLeftAndUpRightToCenter,
  FaEllipsis,
  FaEllipsisVertical,
  FaEnvelope,
  FaEnvelopeOpen,
  FaExpand,
  FaEye,
  FaEyeSlash,
  FaFile,
  FaFileArrowDown,
  FaFileCirclePlus,
  FaFileCode,
  FaFileCsv,
  FaFileExcel,
  FaFileExport,
  FaFileLines,
  FaFilePdf,
  FaFilePowerpoint,
  FaFileWord,
  FaFilter,
  FaFloppyDisk,
  FaFolder,
  FaFolderOpen,
  FaFolderPlus,
  FaFont,
  FaGauge,
  FaGear,
  FaGears,
  FaGlobe,
  FaGraduationCap,
  FaGrip,
  FaGripLines,
  FaGripLinesVertical,
  FaGripVertical,
  FaHourglassHalf,
  FaHouse,
  FaIdBadge,
  FaIdCard,
  FaImage,
  FaImages,
  FaInbox,
  FaIntercom,
  FaKey,
  FaLeftLong,
  FaLeftRight,
  FaLightbulb,
  FaLink,
  FaLinkSlash,
  FaList,
  FaListOl,
  FaListUl,
  FaLocationDot,
  FaLock,
  FaLockOpen,
  FaMagnifyingGlass,
  FaMagnifyingGlassMinus,
  FaMagnifyingGlassPlus,
  FaMessage,
  FaMicrosoft,
  FaMinus,
  FaMoneyCheckDollar,
  FaMugHot,
  FaPaintbrush,
  FaPaperPlane,
  FaPaperclip,
  FaPen,
  FaPenToSquare,
  FaPencil,
  FaPersonWalkingArrowLoopLeft,
  FaPiggyBank,
  FaPlus,
  FaPowerOff,
  FaPrint,
  FaRegCircleQuestion,
  FaRegLightbulb,
  FaReply,
  FaRightFromBracket,
  FaRightLeft,
  FaRightLong,
  FaRightToBracket,
  FaRobot,
  FaRocket,
  FaRotate,
  FaRotateLeft,
  FaShareNodes,
  FaShieldHalved,
  FaSliders,
  FaSort,
  FaSortDown,
  FaSortUp,
  FaSquareCheck,
  FaSquareMinus,
  FaSquarePlus,
  FaSquarePollVertical,
  FaStar,
  FaSuitcaseMedical,
  FaTable,
  FaTableColumns,
  FaTableList,
  FaTag,
  FaTags,
  FaThumbtack,
  FaToolbox,
  FaTrashCan,
  FaTriangleExclamation,
  FaTruck,
  FaTruckRampBox,
  FaUpDown,
  FaUpRightAndDownLeftFromCenter,
  FaUser,
  FaUserCheck,
  FaUserClock,
  FaUserLarge,
  FaUserPen,
  FaUserPlus,
  FaUsers,
  FaWindowMaximize,
  FaWindowMinimize,
  FaWindowRestore,
  FaXmark,
  FaYenSign,
} from 'react-icons/fa6'

import { generateIcon } from './generateIcon'

export const FaAddressBookIcon = /*#__PURE__*/ generateIcon(FaAddressBook)
export const FaAddressCardIcon = /*#__PURE__*/ generateIcon(FaAddressCard)
export const FaAngleDownIcon = /*#__PURE__*/ generateIcon(FaAngleDown)
export const FaAngleLeftIcon = /*#__PURE__*/ generateIcon(FaAngleLeft)
export const FaAngleRightIcon = /*#__PURE__*/ generateIcon(FaAngleRight)
export const FaAngleUpIcon = /*#__PURE__*/ generateIcon(FaAngleUp)
export const FaAnglesLeftIcon = /*#__PURE__*/ generateIcon(FaAnglesLeft)
export const FaAnglesRightIcon = /*#__PURE__*/ generateIcon(FaAnglesRight)
export const FaArrowDownIcon = /*#__PURE__*/ generateIcon(FaArrowDown)
export const FaArrowDownWideShortIcon = /*#__PURE__*/ generateIcon(FaArrowDownWideShort)
export const FaArrowLeftIcon = /*#__PURE__*/ generateIcon(FaArrowLeft)
export const FaArrowRightIcon = /*#__PURE__*/ generateIcon(FaArrowRight)
export const FaArrowRightArrowLeftIcon = /*#__PURE__*/ generateIcon(FaArrowRightArrowLeft)
export const FaArrowRotateLeftIcon = /*#__PURE__*/ generateIcon(FaArrowRotateLeft)
export const FaArrowRotateRightIcon = /*#__PURE__*/ generateIcon(FaArrowRotateRight)
export const FaArrowUp19Icon = /*#__PURE__*/ generateIcon(FaArrowUp19)
export const FaArrowUpIcon = /*#__PURE__*/ generateIcon(FaArrowUp)
export const FaArrowUpWideShortIcon = /*#__PURE__*/ generateIcon(FaArrowUpWideShort)
export const FaArrowsRotateIcon = /*#__PURE__*/ generateIcon(FaArrowsRotate)
export const FaAsteriskIcon = /*#__PURE__*/ generateIcon(FaAsterisk)
export const FaAtIcon = /*#__PURE__*/ generateIcon(FaAt)
export const FaBabyCarriageIcon = /*#__PURE__*/ generateIcon(FaBabyCarriage)
export const FaBanIcon = /*#__PURE__*/ generateIcon(FaBan)
export const FaBarsIcon = /*#__PURE__*/ generateIcon(FaBars)
export const FaBarsStaggeredIcon = /*#__PURE__*/ generateIcon(FaBarsStaggered)
export const FaBellIcon = /*#__PURE__*/ generateIcon(FaBell)
export const FaBellSlashIcon = /*#__PURE__*/ generateIcon(FaBellSlash)
export const FaBoltIcon = /*#__PURE__*/ generateIcon(FaBolt)
export const FaBookIcon = /*#__PURE__*/ generateIcon(FaBook)
export const FaBookOpenIcon = /*#__PURE__*/ generateIcon(FaBookOpen)
export const FaBookmarkIcon = /*#__PURE__*/ generateIcon(FaBookmark)
export const FaBoxArchiveIcon = /*#__PURE__*/ generateIcon(FaBoxArchive)
export const FaBuildingIcon = /*#__PURE__*/ generateIcon(FaBuilding)
export const FaBullhornIcon = /*#__PURE__*/ generateIcon(FaBullhorn)
export const FaCakeCandlesIcon = /*#__PURE__*/ generateIcon(FaCakeCandles)
export const FaCalculatorIcon = /*#__PURE__*/ generateIcon(FaCalculator)
export const FaCalendarCheckIcon = /*#__PURE__*/ generateIcon(FaCalendarCheck)
export const FaCalendarDaysIcon = /*#__PURE__*/ generateIcon(FaCalendarDays)
export const FaCalendarXmarkIcon = /*#__PURE__*/ generateIcon(FaCalendarXmark)
export const FaCameraIcon = /*#__PURE__*/ generateIcon(FaCamera)
export const FaCaretDownIcon = /*#__PURE__*/ generateIcon(FaCaretDown)
export const FaCaretLeftIcon = /*#__PURE__*/ generateIcon(FaCaretLeft)
export const FaCaretRightIcon = /*#__PURE__*/ generateIcon(FaCaretRight)
export const FaCaretUpIcon = /*#__PURE__*/ generateIcon(FaCaretUp)
export const FaChartAreaIcon = /*#__PURE__*/ generateIcon(FaChartArea)
export const FaChartBarIcon = /*#__PURE__*/ generateIcon(FaChartBar)
export const FaChartColumnIcon = /*#__PURE__*/ generateIcon(FaChartColumn)
export const FaChartLineIcon = /*#__PURE__*/ generateIcon(FaChartLine)
export const FaChartPieIcon = /*#__PURE__*/ generateIcon(FaChartPie)
export const FaCheckIcon = /*#__PURE__*/ generateIcon(FaCheck)
export const FaChevronDownIcon = /*#__PURE__*/ generateIcon(FaChevronDown)
export const FaChevronLeftIcon = /*#__PURE__*/ generateIcon(FaChevronLeft)
export const FaChevronRightIcon = /*#__PURE__*/ generateIcon(FaChevronRight)
export const FaCircleCheckIcon = /*#__PURE__*/ generateIcon(FaCircleCheck)
export const FaCircleDotIcon = /*#__PURE__*/ generateIcon(FaCircleDot)
export const FaCircleExclamationIcon = /*#__PURE__*/ generateIcon(FaCircleExclamation)
export const FaCircleIcon = /*#__PURE__*/ generateIcon(FaCircle)
export const FaCircleInfoIcon = /*#__PURE__*/ generateIcon(FaCircleInfo)
export const FaCircleMinusIcon = /*#__PURE__*/ generateIcon(FaCircleMinus)
export const FaCirclePlayIcon = /*#__PURE__*/ generateIcon(FaCirclePlay)
export const FaCirclePlusIcon = /*#__PURE__*/ generateIcon(FaCirclePlus)
export const FaCircleQuestionIcon = /*#__PURE__*/ generateIcon(FaCircleQuestion)
export const FaCircleUserIcon = /*#__PURE__*/ generateIcon(FaCircleUser)
export const FaCircleXmarkIcon = /*#__PURE__*/ generateIcon(FaCircleXmark)
export const FaClipboardCheckIcon = /*#__PURE__*/ generateIcon(FaClipboardCheck)
export const FaClipboardIcon = /*#__PURE__*/ generateIcon(FaClipboard)
export const FaClipboardListIcon = /*#__PURE__*/ generateIcon(FaClipboardList)
export const FaClipboardQuestionIcon = /*#__PURE__*/ generateIcon(FaClipboardQuestion)
export const FaClockIcon = /*#__PURE__*/ generateIcon(FaClock)
export const FaClockRotateLeftIcon = /*#__PURE__*/ generateIcon(FaClockRotateLeft)
export const FaCloudArrowDownIcon = /*#__PURE__*/ generateIcon(FaCloudArrowDown)
export const FaCloudArrowUpIcon = /*#__PURE__*/ generateIcon(FaCloudArrowUp)
export const FaCodeIcon = /*#__PURE__*/ generateIcon(FaCode)
export const FaCommentDotsIcon = /*#__PURE__*/ generateIcon(FaCommentDots)
export const FaCommentIcon = /*#__PURE__*/ generateIcon(FaComment)
export const FaCommentsIcon = /*#__PURE__*/ generateIcon(FaComments)
export const FaCompressIcon = /*#__PURE__*/ generateIcon(FaCompress)
export const FaCopyIcon = /*#__PURE__*/ generateIcon(FaCopy)
export const FaCubeIcon = /*#__PURE__*/ generateIcon(FaCube)
export const FaCubesIcon = /*#__PURE__*/ generateIcon(FaCubes)
export const FaDatabaseIcon = /*#__PURE__*/ generateIcon(FaDatabase)
export const FaDoorOpenIcon = /*#__PURE__*/ generateIcon(FaDoorOpen)
export const FaDownLeftAndUpRightToCenterIcon = /*#__PURE__*/ generateIcon(
  FaDownLeftAndUpRightToCenter,
)
export const FaEllipsisIcon = /*#__PURE__*/ generateIcon(FaEllipsis)
export const FaEllipsisVerticalIcon = /*#__PURE__*/ generateIcon(FaEllipsisVertical)
export const FaEnvelopeIcon = /*#__PURE__*/ generateIcon(FaEnvelope)
export const FaEnvelopeOpenIcon = /*#__PURE__*/ generateIcon(FaEnvelopeOpen)
export const FaExpandIcon = /*#__PURE__*/ generateIcon(FaExpand)
export const FaEyeIcon = /*#__PURE__*/ generateIcon(FaEye)
export const FaEyeSlashIcon = /*#__PURE__*/ generateIcon(FaEyeSlash)
export const FaFileArrowDownIcon = /*#__PURE__*/ generateIcon(FaFileArrowDown)
export const FaFileCirclePlusIcon = /*#__PURE__*/ generateIcon(FaFileCirclePlus)
export const FaFileCodeIcon = /*#__PURE__*/ generateIcon(FaFileCode)
export const FaFileCsvIcon = /*#__PURE__*/ generateIcon(FaFileCsv)
export const FaFileExcelIcon = /*#__PURE__*/ generateIcon(FaFileExcel)
export const FaFileExportIcon = /*#__PURE__*/ generateIcon(FaFileExport)
export const FaFileIcon = /*#__PURE__*/ generateIcon(FaFile)
export const FaFileLinesIcon = /*#__PURE__*/ generateIcon(FaFileLines)
export const FaFilePdfIcon = /*#__PURE__*/ generateIcon(FaFilePdf)
export const FaFilePowerpointIcon = /*#__PURE__*/ generateIcon(FaFilePowerpoint)
export const FaFileWordIcon = /*#__PURE__*/ generateIcon(FaFileWord)
export const FaFilterIcon = /*#__PURE__*/ generateIcon(FaFilter)
export const FaFloppyDiskIcon = /*#__PURE__*/ generateIcon(FaFloppyDisk)
export const FaFolderIcon = /*#__PURE__*/ generateIcon(FaFolder)
export const FaFolderOpenIcon = /*#__PURE__*/ generateIcon(FaFolderOpen)
export const FaFolderPlusIcon = /*#__PURE__*/ generateIcon(FaFolderPlus)
export const FaFontIcon = /*#__PURE__*/ generateIcon(FaFont)
export const FaGaugeIcon = /*#__PURE__*/ generateIcon(FaGauge)
export const FaGearIcon = /*#__PURE__*/ generateIcon(FaGear)
export const FaGearsIcon = /*#__PURE__*/ generateIcon(FaGears)
export const FaGlobeIcon = /*#__PURE__*/ generateIcon(FaGlobe)
export const FaGraduationCapIcon = /*#__PURE__*/ generateIcon(FaGraduationCap)
export const FaGripIcon = /*#__PURE__*/ generateIcon(FaGrip)
export const FaGripLinesIcon = /*#__PURE__*/ generateIcon(FaGripLines)
export const FaGripLinesVerticalIcon = /*#__PURE__*/ generateIcon(FaGripLinesVertical)
export const FaGripVerticalIcon = /*#__PURE__*/ generateIcon(FaGripVertical)
export const FaHourglassHalfIcon = /*#__PURE__*/ generateIcon(FaHourglassHalf)
export const FaHouseIcon = /*#__PURE__*/ generateIcon(FaHouse)
export const FaIdBadgeIcon = /*#__PURE__*/ generateIcon(FaIdBadge)
export const FaIdCardIcon = /*#__PURE__*/ generateIcon(FaIdCard)
export const FaImageIcon = /*#__PURE__*/ generateIcon(FaImage)
export const FaImagesIcon = /*#__PURE__*/ generateIcon(FaImages)
export const FaInboxIcon = /*#__PURE__*/ generateIcon(FaInbox)
export const FaIntercomIcon = /*#__PURE__*/ generateIcon(FaIntercom)
export const FaKeyIcon = /*#__PURE__*/ generateIcon(FaKey)
export const FaLeftLongIcon = /*#__PURE__*/ generateIcon(FaLeftLong)
export const FaLeftRightIcon = /*#__PURE__*/ generateIcon(FaLeftRight)
export const FaLightbulbIcon = /*#__PURE__*/ generateIcon(FaLightbulb)
export const FaLinkIcon = /*#__PURE__*/ generateIcon(FaLink)
export const FaLinkSlashIcon = /*#__PURE__*/ generateIcon(FaLinkSlash)
export const FaListIcon = /*#__PURE__*/ generateIcon(FaList)
export const FaListOlIcon = /*#__PURE__*/ generateIcon(FaListOl)
export const FaListUlIcon = /*#__PURE__*/ generateIcon(FaListUl)
export const FaLocationDotIcon = /*#__PURE__*/ generateIcon(FaLocationDot)
export const FaLockIcon = /*#__PURE__*/ generateIcon(FaLock)
export const FaLockOpenIcon = /*#__PURE__*/ generateIcon(FaLockOpen)
export const FaMagnifyingGlassIcon = /*#__PURE__*/ generateIcon(FaMagnifyingGlass)
export const FaMagnifyingGlassMinusIcon = /*#__PURE__*/ generateIcon(FaMagnifyingGlassMinus)
export const FaMagnifyingGlassPlusIcon = /*#__PURE__*/ generateIcon(FaMagnifyingGlassPlus)
export const FaMessageIcon = /*#__PURE__*/ generateIcon(FaMessage)
export const FaMicrosoftIcon = /*#__PURE__*/ generateIcon(FaMicrosoft)
export const FaMinusIcon = /*#__PURE__*/ generateIcon(FaMinus)
export const FaMoneyCheckDollarIcon = /*#__PURE__*/ generateIcon(FaMoneyCheckDollar)
export const FaMugHotIcon = /*#__PURE__*/ generateIcon(FaMugHot)
export const FaPaintbrushIcon = /*#__PURE__*/ generateIcon(FaPaintbrush)
export const FaPaperPlaneIcon = /*#__PURE__*/ generateIcon(FaPaperPlane)
export const FaPaperclipIcon = /*#__PURE__*/ generateIcon(FaPaperclip)
export const FaPenIcon = /*#__PURE__*/ generateIcon(FaPen)
export const FaPenToSquareIcon = /*#__PURE__*/ generateIcon(FaPenToSquare)
export const FaPencilIcon = /*#__PURE__*/ generateIcon(FaPencil)
export const FaPersonWalkingArrowLoopLeftIcon = /*#__PURE__*/ generateIcon(
  FaPersonWalkingArrowLoopLeft,
)
export const FaPiggyBankIcon = /*#__PURE__*/ generateIcon(FaPiggyBank)
export const FaPlusIcon = /*#__PURE__*/ generateIcon(FaPlus)
export const FaPowerOffIcon = /*#__PURE__*/ generateIcon(FaPowerOff)
export const FaPrintIcon = /*#__PURE__*/ generateIcon(FaPrint)
export const FaRegCircleQuestionIcon = /*#__PURE__*/ generateIcon(FaRegCircleQuestion)
export const FaRegLightbulbIcon = /*#__PURE__*/ generateIcon(FaRegLightbulb)
export const FaReplyIcon = /*#__PURE__*/ generateIcon(FaReply)
export const FaRightFromBracketIcon = /*#__PURE__*/ generateIcon(FaRightFromBracket)
export const FaRightLeftIcon = /*#__PURE__*/ generateIcon(FaRightLeft)
export const FaRightLongIcon = /*#__PURE__*/ generateIcon(FaRightLong)
export const FaRightToBracketIcon = /*#__PURE__*/ generateIcon(FaRightToBracket)
export const FaRobotIcon = /*#__PURE__*/ generateIcon(FaRobot)
export const FaRocketIcon = /*#__PURE__*/ generateIcon(FaRocket)
export const FaRotateIcon = /*#__PURE__*/ generateIcon(FaRotate)
export const FaRotateLeftIcon = /*#__PURE__*/ generateIcon(FaRotateLeft)
export const FaShareNodesIcon = /*#__PURE__*/ generateIcon(FaShareNodes)
export const FaShieldHalvedIcon = /*#__PURE__*/ generateIcon(FaShieldHalved)
export const FaSlidersIcon = /*#__PURE__*/ generateIcon(FaSliders)
export const FaSortDownIcon = /*#__PURE__*/ generateIcon(FaSortDown)
export const FaSortIcon = /*#__PURE__*/ generateIcon(FaSort)
export const FaSortUpIcon = /*#__PURE__*/ generateIcon(FaSortUp)
export const FaSquareCheckIcon = /*#__PURE__*/ generateIcon(FaSquareCheck)
export const FaSquareMinusIcon = /*#__PURE__*/ generateIcon(FaSquareMinus)
export const FaSquarePlusIcon = /*#__PURE__*/ generateIcon(FaSquarePlus)
export const FaSquarePollVerticalIcon = /*#__PURE__*/ generateIcon(FaSquarePollVertical)
export const FaStarIcon = /*#__PURE__*/ generateIcon(FaStar)
export const FaSuitcaseMedicalIcon = /*#__PURE__*/ generateIcon(FaSuitcaseMedical)
export const FaTableIcon = /*#__PURE__*/ generateIcon(FaTable)
export const FaTableListIcon = /*#__PURE__*/ generateIcon(FaTableList)
export const FaTableColumnsIcon = /*#__PURE__*/ generateIcon(FaTableColumns)
export const FaTagIcon = /*#__PURE__*/ generateIcon(FaTag)
export const FaTagsIcon = /*#__PURE__*/ generateIcon(FaTags)
export const FaThumbtackIcon = /*#__PURE__*/ generateIcon(FaThumbtack)
export const FaToolboxIcon = /*#__PURE__*/ generateIcon(FaToolbox)
export const FaTrashCanIcon = /*#__PURE__*/ generateIcon(FaTrashCan)
export const FaTriangleExclamationIcon = /*#__PURE__*/ generateIcon(FaTriangleExclamation)
export const FaTruckIcon = /*#__PURE__*/ generateIcon(FaTruck)
export const FaTruckRampBoxIcon = /*#__PURE__*/ generateIcon(FaTruckRampBox)
export const FaUpDownIcon = /*#__PURE__*/ generateIcon(FaUpDown)
export const FaUpRightAndDownLeftFromCenterIcon = /*#__PURE__*/ generateIcon(
  FaUpRightAndDownLeftFromCenter,
)
export const FaUserCheckIcon = /*#__PURE__*/ generateIcon(FaUserCheck)
export const FaUserClockIcon = /*#__PURE__*/ generateIcon(FaUserClock)
export const FaUserIcon = /*#__PURE__*/ generateIcon(FaUser)
export const FaUserLargeIcon = /*#__PURE__*/ generateIcon(FaUserLarge)
export const FaUserPenIcon = /*#__PURE__*/ generateIcon(FaUserPen)
export const FaUserPlusIcon = /*#__PURE__*/ generateIcon(FaUserPlus)
export const FaUsersIcon = /*#__PURE__*/ generateIcon(FaUsers)
export const FaWindowMaximizeIcon = /*#__PURE__*/ generateIcon(FaWindowMaximize)
export const FaWindowMinimizeIcon = /*#__PURE__*/ generateIcon(FaWindowMinimize)
export const FaWindowRestoreIcon = /*#__PURE__*/ generateIcon(FaWindowRestore)
export const FaXmarkIcon = /*#__PURE__*/ generateIcon(FaXmark)
export const FaYenSignIcon = /*#__PURE__*/ generateIcon(FaYenSign)
